const RunningAdComp = ({ runningAd }) => {
  console.log(runningAd.adTime);
  console.log(((runningAd.adTime - runningAd.timeLeft) / runningAd.adTime) * 100 * 2);
  let imageUrlActive = `${runningAd.adImage.split("/upload/")[0]}/upload/f_auto,q_auto,w_420/${runningAd.adImage.split("/upload/")[1]}`;
  return (
    <>
      <div className='runningAdDiv'>
        <div className='runningAd'>
          <div className='runningAdImageDIv3'>
            <img src={imageUrlActive} />
          </div>
          <div>
            <div>
              <span className='adParametersTilt'>Time left:</span>
              <div className='circleTimeDIv'>
                <svg id='svgCircleTime' height='70' width='70'>
                  <defs>
                    <linearGradient id='guageLinrGrad'>
                      <stop offset='0%' stopColor='#98e9ce' />
                      <stop offset='100%' stopColor='#00B87C' />
                    </linearGradient>
                  </defs>
                  <circle id='circleTimeTrack' cx={35} cy={35} r='32' strokeLinecap='round' />
                  <circle
                    style={{ strokeDashoffset: `${((runningAd.adTime - runningAd.timeLeft) / runningAd.adTime) * 100 * 2}` }}
                    id='circleTime'
                    cx={35}
                    cy={35}
                    r='32'
                    strokeLinecap='round'
                  />
                </svg>
                <div className='circleTrackTime'>
                  {runningAd.timeLeft < 1 ? (
                    <p style={{ color: "red" }}>Expired</p>
                  ) : runningAd.adTime > 99 ? (
                    Math.ceil(runningAd.timeLeft / 24) + " " + "days"
                  ) : (
                    <p>{runningAd.timeLeft + " " + "hours"}</p>
                  )}
                </div>
              </div>
            </div>
            <div>
              <span className='adParametersTilt'>Ad time:</span>
              <span>{runningAd.adTime > 99 ? runningAd.adTime / 24 + " " + "days" : runningAd.adTime + " " + "hours"} </span>
            </div>
            <div>
              <span className='adParametersTilt'>Clicks:</span>
              <span>{runningAd.clicksOnAd}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RunningAdComp;
